const LINKS = {
	TUTORIAL_VIDEO: 'https://www.dropbox.com/scl/fi/w5zgxwj07oaqaaner1vnh/Cad_usuarios_OG.mp4?rlkey=pkz5cq5op6tgr4levy5qnhco8&e=2&st=2lezsz4c&dl=0',
	SIGNUP: '/signup'
};

export default LINKS;